import { service } from 'services';
import { hotGetAction } from 'utils';
import { ACTIONS_TYPES } from '../helper';

export default {
  getProfile: async () => hotGetAction({
    action: ACTIONS_TYPES.BILLING.GET_PROFILE,
    apiResult: service.billing.getProfile(),
  }),

  getProducts: async ({ contractId }) => hotGetAction({
    action: ACTIONS_TYPES.BILLING.GET_PRODUCTS,
    apiResult: service.billing.getProducts({ contractId }),
  }),

  getUsage: async ({ contractId }) => hotGetAction({
    action: ACTIONS_TYPES.BILLING.GET_USAGE,
    apiResult: service.billing.getUsage({ contractId }),
  }),

  getUsageByDatacenter: async ({ contractId, datacenterId }) => hotGetAction({
    action: ACTIONS_TYPES.BILLING.GET_USAGE_BY_DATACENTER,
    apiResult: service.billing.getUsageByDatacenter({ contractId, datacenterId }),
  }),

  getInvoices: async ({ contractId }) => hotGetAction({
    action: ACTIONS_TYPES.BILLING.GET_INVOICES,
    apiResult: service.billing.getInvoices({ contractId }),
  }),

  getInvoicesById: async ({ contractId, invoiceId }) => hotGetAction({
    action: ACTIONS_TYPES.BILLING.GET_INVOICES_BY_ID,
    apiResult: service.billing.getInvoicesById({ contractId, invoiceId }),
  }),

  getInvoicesByPeriod: async ({ contractId, period }) => hotGetAction({
    action: ACTIONS_TYPES.BILLING.GET_INVOICES_BY_PERIOD,
    apiResult: service.billing.getInvoicesByPeriod({ contractId, period }),
  }),

  getTraffic: async ({ contractId }) => hotGetAction({
    action: ACTIONS_TYPES.BILLING.GET_TRAFFIC,
    apiResult: service.billing.getProducts({ contractId }),
  }),

  getTrafficByPeriod: async ({ contractId }) => hotGetAction({
    action: ACTIONS_TYPES.BILLING.GET_TRAFFIC_BY_PERIOD,
    apiResult: service.billing.getProducts({ contractId }),
  }),

  getEvn: async ({ contractId }) => hotGetAction({
    action: ACTIONS_TYPES.BILLING.GET_EVN,
    apiResult: service.billing.getProducts({ contractId }),
  }),

  getEvnByPeriod: async ({ contractId }) => hotGetAction({
    action: ACTIONS_TYPES.BILLING.GET_EVN_BY_PERIOD,
    apiResult: service.billing.getProducts({ contractId }),
  }),
};
